import http from '@http';

function state() {
    return {
        items: {},
        types: [],
    };
}

const getters = {
    getRoom: (state) => (id) => state.items[id],
    rooms: (state) => Object.keys(state.items).map((id) => state.items[id]),
    activeRooms: (state, getters) => getters.rooms.filter((i) => i.isActive),
    types: (state) => state.types,
};

const mutations = {
    set(state, payload) {
        state.items[payload.id] = payload;
    },
    setTypes(state, types) {
        state['types'] = types;
    },
    reset(storeState) {
        const s = state();
        Object.keys(s).forEach((key) => (storeState[key] = s[key]));
    },
};

const actions = {
    onPlaceChange: {
        root: true,
        handler({ commit }) {
            commit('reset');
        },
    },
    async getAll({ commit, rootGetters }) {
        try {
            commit('reset');
            const response = await http.get(`/api/place/${rootGetters.selectedPlaceId}/rooms`);
            response.data.forEach((room) => {
                commit('set', fromJSON(room));
            });
        } catch (error) {
            console.error(new Error(error?.response?.data?.message || error.message || 'error'));
        }
    },
    async get({ commit, rootGetters }, id) {
        try {
            const response = await http.get(`/api/place/${rootGetters.selectedPlaceId}/rooms/${id}`);
            commit('set', fromJSON(response.data));
        } catch (error) {
            console.error(new Error(error?.response?.data?.message || error.message || 'error'));
        }
    },
    async create({ commit, rootGetters, dispatch }, payload) {
        try {
            const sensor = await dispatch('sensor/change', payload.sensor, { root: true });
            if (!sensor && payload?.sensor?.name) {
                return false;
            }

            const response = await http.post(
                `/api/place/${rootGetters.selectedPlaceId}/rooms`,
                toJSON({ ...payload, sensor })
            );
            const data = fromJSON(response.data);
            commit('set', data);

            return data;
        } catch (error) {
            console.error(new Error(error?.response?.data?.message || error.message || 'error'));
        }
    },
    async update({ commit, rootGetters, dispatch }, payload) {
        try {
            const sensor = await dispatch('sensor/change', payload.sensor, { root: true });
            if (!sensor && payload?.sensor?.name) {
                return false;
            }

            const response = await http.put(
                `/api/place/${rootGetters.selectedPlaceId}/rooms/${payload.id}`,
                toJSON({ ...payload, sensor })
            );
            const data = fromJSON(response.data);
            commit('set', data);

            return data;
        } catch (error) {
            console.error(new Error(error?.response?.data?.message || error.message || 'error'));
        }
    },
    async toggleActivation({ dispatch, getters }, id) {
        const room = getters.getRoom(id);

        dispatch('update', {
            ...room,
            isActive: !room.isActive,
        });
    },
    async getTypes({ getters, commit, rootGetters }) {
        if (getters.types?.length) {
            return getters.types;
        }

        try {
            const response = await http.get(`/api/place/${rootGetters.selectedPlaceId}/rooms/types`);

            commit('setTypes', response.data);

            return getters.types;
        } catch (error) {
            console.error(new Error(error?.response?.data?.message || error.message || 'error'));
        }
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};

function fromJSON(json) {
    return {
        id: json.id,
        name: json.name,
        area: json.size,
        sensor: {
            id: json?.sensor?.id,
            name: json?.sensor?.name,
            below: json?.sensor?.lower_error_margin,
            above: json?.sensor?.upper_error_margin,
            sendNotificationAfter: json?.sensor?.max_error_count,
        },
        type: json.room_type?.id,
        isDefault: json.is_default,
        isActive: !json.is_disabled,
        tasksGroups:
            json.entity_task_subtypes?.map((group) => ({
                id: group.id,
                subtypeId: group.task_subtype?.id,
                isActive: group.is_active,
                orderNumber: group.order_number,
                name: group.task_subtype?.name,
            })) || [],
    };
}

function toJSON(data) {
    return {
        id: data.id,
        name: data.name,
        size: data.area,
        sensor: {
            id: data?.sensor?.id,
            name: data?.sensor?.name,
            below: data?.sensor?.below,
            above: data?.sensor?.above,
            sendNotificationAfter: data?.sensor?.sendNotificationAfter,
        },
        room_type: {
            id: data.type,
        },
        is_disabled: !data.isActive,
        entity_task_subtypes:
            data.tasksGroups?.map((group) => ({
                id: group.id,
                is_active: group.isActive,
                order_number: group.orderNumber,
                task_subtype: {
                    name: group.name,
                },
            })) || [],
    };
}
